import React, { useEffect, useState } from "react";
import IDXChip from "../../ComponentsUI/IDXChip/IDXChip";

interface ContainerProps {
    searchValue: string;
    filters: string[];
    tagCallback: (tag: string) => void;
    sport: string;
    feature?: string;
    sportCallback: (sport: string, resetFilters: boolean) => void;
    searchCallback: (search: string) => void;
}

const SearchBarFilter: React.FC<ContainerProps> = (props: ContainerProps) => {
    const [placeholder, setPlaceholder] = useState('');

    const handleDropTag = (tag: string) => {
        props.tagCallback!(tag);
    }

    useEffect(() => {

    }, [props.filters, props.sport, props.searchValue]);

    // TODO: animate placeholder for search bar when clicked on but nothing typed in

    const toTitleCase = (str: string) => {
        return str.toLowerCase().split(' ').map(function (word) {
            return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }

    const formatTag = (tag: string) => {
        tag = tag.trim();
        tag = tag.replaceAll('_', ' ');
        return tag.replace(
            /\w\S*/g,
            function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            })
    }

    // Convert API value to display name for features
    const getFeatureDisplayName = (apiValue: string): string => {
        if (!apiValue) return "";
        const featureMap: Record<string, string> = {
            'off_snow': 'Off-Snow',
            'mountain': 'Freeride',
            'rail': 'Rail/Jib',
            'jump': 'Jump',
            'halfpipe': 'Halfpipe',
        };
        return featureMap[apiValue.toLowerCase()] || formatTag(apiValue);
    };

    const hasContent =
        (props.sport !== '' && props.sport !== undefined && props.sport !== null) ||
        (props.feature !== '' && props.feature !== undefined && props.feature !== null) ||
        (props?.filters.length > 0);

    return (
        hasContent &&
        <div className="flex flex-row flex-nowrap font-bold text-xl overflow-x-auto mx-4 gap-x-1 mt-1.5 mb-1.5">
            {props.sport !== '' && props.sport !== undefined && props.sport !== null ?
                <IDXChip bgColor='bg-transparent'
                    borderColor='border-2 border-highlight-alt' text={props.sport}></IDXChip> : <div></div>}
            {props.feature !== '' && props.feature !== undefined && props.feature !== null ?
                <IDXChip bgColor='bg-transparent'
                    borderColor='border-2 border-highlight-secondary' text={getFeatureDisplayName(props.feature)}></IDXChip> : <div></div>}
            {props.searchValue !== '' && props.searchValue !== undefined && props.searchValue !== null ?
                <IDXChip bgColor='bg-transparent'
                    borderColor='border-2 border-primary-secondary' text={props.searchValue}></IDXChip> :
                <div></div>}
            {props.filters.map((tag, index) => (
                <IDXChip key={index} bgColor="bg-transparent"
                    borderColor='border-2 border-primary-secondary'
                    text={formatTag(tag)}></IDXChip>))}
        </div>
    );
};

export default SearchBarFilter;
